import { IAddressComponent, IGeocodingLocation } from '../../../../../core/src'

const geocodingZipCodeIdentifier = 'postal_code'

export class GeocodingLocationFactory {
  // There are cases where a google response might NOT have a zip code, and because multiple events
  // may be triggered from this component, we could end up overwritting an emitted zip code.
  static fromGeocodingArrayFactory(rows: IAddressComponent[]): IGeocodingLocation {
    const zipCodeComponent = rows.find((e) => e.types?.includes(geocodingZipCodeIdentifier))
    return {
      zipCode: zipCodeComponent?.long_name
    }
  }
}
